export default __webpack_public_path__ + "static/media/chatBubbleIcon.21d0af7d.svg";